<template>
  <div
    class="flex gap-1 h-full w-full border rounded
    text-EXPONDO-black relative overflow-hidden p-2"
    :class="{'border-EXPONDO-secondary': isChecked }"
  >
    <CustomLink
      :url="link"
      :type="LINK_TYPE.NoStyle"
      class="flex-shrink-0 self-center"
      @link-click="onClick"
    >
      <TwicpicsImage
        img-classes="h-20 w-20"
        :src="image"
        :alt="title"
        :width="VERTICAL_PRODUCT_CARD.IMAGE_WIDTH"
        :height="VERTICAL_PRODUCT_CARD.IMAGE_HEIGHT"
      />
    </CustomLink>
    <div class="flex flex-col gap-1 justify-between flex-grow">
      <CustomLink
        :url="link"
        :type="LINK_TYPE.NoStyle"
        @link-click="onClick"
      >
        <div
          class="flex flex-col gap-1"
        >
          <div
            v-if="rating"
            class="h-6.5"
          >
                          <ProductAverageReview
                :rating="ratingToShow"
                :is-card-reviews="true"
              />
          </div>
          <div
            v-if="showCardBadge"
            class="h-7"
          >
                          <ProductCardBadges
                :tags="tags"
              />
          </div>
          <div class="text-sm underline leading-tight line-clamp-3">
            {{ title }}
          </div>
        </div>
      </CustomLink>
      <EnergyRating
        v-if="energyRating"
        :energy-rating="energyRating"
        :size="ENERGY_RATING_SIZE.MEDIUM"
      />
      <CustomLink
        :url="link"
        :type="LINK_TYPE.NoStyle"
        @link-click="onClick"
      >
        <ProductCardPricing
          :full-product-price="fullProductPrice"
          :discounted-price="discountedPrice"
          :is-discounted="isDiscounted"
          :last30-days-price="last30DaysPrice"
          :size="PRODUCT_PRICING_SIZE.SMALL"
        />
      </CustomLink>
    </div>
    <CheckBox
      data-testid="productCardTileCheckbox"
      :is-checked="isChecked"
      is-rectangular
      class="flex-shrink-0"
      @change="$emit('checkBoxClicked')"
    />
  </div>
</template>

<script lang="ts">

import { defineAsyncComponent } from 'vue';

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import type { ProductTag } from '~~/types/product/attribute/ProductTag';
import buildProductRating from '~~/helpers/product/buildProductRating';
import type { EnergyRatingDetails } from '~~/types/components/EnergyRating/EnergyRatingDetails';
import { VERTICAL_PRODUCT_CARD } from '~~/constants/productCard';
import { ENERGY_RATING_SIZE } from '~~/constants/energyRating';
import { PRODUCT_PRICING_SIZE } from '~~/constants/productCardPricing';
export default defineComponent({
  name: 'ProductCardTile',
  components: {
    
    ProductCardBadges: defineAsyncComponent(() => import('~/components/molecules/Product/ProductCardBadges.vue')),
    
    ProductAverageReview: defineAsyncComponent(() => import(/* webpackChunkName: "ProductAverageReview" */
      '~/components/atoms/Product/ProductAverageReview.vue')),
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    fullProductPrice: {
      type: Number,
      required: true,
    },
    discountedPrice: {
      type: Number,
      default: null,
    },
    isDiscounted: {
      type: Boolean,
      default: false,
    },
    last30DaysPrice: {
      type: Number,
      default: null,
    },
    isChecked: {
      type: Boolean,
      default: true,
    },
    reviewsCount: {
      type: Number,
      default: 0,
    },
    rating: {
      type: Number,
      default: 0,
    },
    image: {
      type: String,
      default: '',
    },
    tags: {
      type: Array as PropType<ProductTag[]>,
      default: () => {

        return [];
      
      },
    },
    brand: {
      type: String,
      default: '',
    },
    energyRating: {
      type: Object as PropType<Maybe<EnergyRatingDetails>>,
      default: (): Maybe<EnergyRatingDetails> => null,
    },
  },
  emits: ['checkBoxClicked', 'product-clicked'],
  setup(props, { emit }) {

    const showCardBadge = computed(() => props.tags?.length);
    const ratingToShow = computed(() => {

      return buildProductRating({
        averageRating: props.rating,
        count: props.reviewsCount,
      });
    
    });

    const onClick = () => {

      emit('product-clicked');
    
    };

    return {
      LINK_TYPE,
      ratingToShow,
      showCardBadge,
      VERTICAL_PRODUCT_CARD,
      ENERGY_RATING_SIZE,
      PRODUCT_PRICING_SIZE,
      onClick,
    };
  
  },
});

</script>
